const configCoupon = {
    coupon: {
        listLayout: 'CouponListDefaultLayout',
        filterLayout: 'CouponFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getCoupon',
        listApiParamSet: {
            ip: 1,
            sp:10,
            odc:"created_at",
            odd:"desc",
        }
    },
    couponCreate: {
        writeLayouts: ['CouponWriteDefaultLayout'], 
        writeFunc: 'writeCoupon',
        writeApiParamSet: {

        },
        parsingData: {
            couponNameKo: 'c_name_ko',
            couponNameEn: 'c_name_en',
            couponNameCn: 'c_name_cn',
            couponBenefit: 'c_benefit',
            couponCount:'c_count'
        },
        writeFailTypes: {
            '-1' : "쿠폰 생성에 실패하였습니다.",
            '-100' : "필수값이 없습니다.",
            '-111' : "발급개수 확인이 필요합니다.",
            '-112' : "지급코인 확인이 필요합니다.",
        },
    },
    couponUpdate: {
        writeLayouts: ['CouponWriteDefaultLayout'],
        getFunc: 'getCoupon',
        detailApiParamsSet: {
            ip: 0
        },
        writeApiParamSet: {

        },
        writeFunc: 'updateCoupon',
        parsingData: {
            couponNameKo: 'c_name_ko',
            couponNameEn: 'c_name_en',
            couponNameCn: 'c_name_cn',
        },
        writeKeyName: 'id',
    },
    couponLink: {
        listLayout: 'CouponMemberListDefaultLayout',
        filterLayout: 'CouponMemberFilterDefaultLayout',
        paginationLayout: 'MemberPaginationDefaultLayout',
        getFunc: 'getCouponLink',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            odc:'cl_idx',
            odd:'desc',
        },
        deleteFunc: 'deleteMemberCoupon'

    }
}

export default {
    methods: {
        returnCouponConfig(type) {
            return configCoupon[type];
        }
    },
    filterConfig: {
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        st: {
            type : 'match',
            classname: 'selectStatus',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
    }
}